import { useLayoutEffect, useState } from 'react';

import { deviceManager } from '../../goloom-sdk';

/**
 * Подписываемся на изменение девайсов и возвращаем стрим из трека активного устройства по kind
 *
 * @param kind - аудио или видео
 * @param withInitialCall - получать ли стрим при монтировании
 */
export function useActiveDeviceStream(kind: 'audioinput' | 'videoinput', withInitialCall?: boolean) {
    const [mediaStream, setMediaStream] = useState<MediaStream>();

    useLayoutEffect(() => {
        const getSdkStream = () => {
            let stream;
            if (kind === 'videoinput') {
                stream = deviceManager.getActiveCameraStream();
            } else {
                stream = deviceManager.getActiveMicrophoneStream();
            }

            setMediaStream(stream);
        };

        if (withInitialCall) {
            getSdkStream();
        }

        // Подписываемся на событие изменения устройства ввода
        deviceManager.onActiveDevicesChanged.addListener(getSdkStream);

        return () => {
            deviceManager.onActiveDevicesChanged.removeListener(getSdkStream);
        };
    }, [kind, withInitialCall]);

    return mediaStream;
}
